import React, { useState } from "react";
import Layout from "../../../components/Layout";
import Container from "../../../components/Container";
import { useHistory } from "react-router-dom";
import Flex from "../../../components/Flex";
import { useAuthState } from "../../../components/AuthProvider";
import Content from "../../../components/Content";
import ButtonList from "../../../components/ButtonList";
import DropDownList from "../../../components/DropDownList";
import LinkButton from "../../../components/LinkButton";
import DataTable from "../../../components/DataTable";
import DefaultBreadcrumbs from "../../../components/DefaultBreadcrumbs";
import _groupBy from "lodash/groupBy";
import Spinner from "../../../components/Loader/Spinner";
import DateTimePicker from "react-datetime-picker";
import Button from "../../../components/Button";
import fetchConfig from "../../../utils/fetchConfig";
import handleFetchResponse from "../../../utils/handleFetchResponse";
import { useMessageToast } from "../../../components/MessageProvider";

import styles from "./DataStewardReport.module.scss";
import { Multiselect } from "multiselect-react-dropdown";
const pako = require("pako");

const DataStewardReport = () => {
  const clientConfigApiDomain = process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN;
  const orgApiUrl = `${clientConfigApiDomain}/organizations`;
  const usersApiUrl = `${clientConfigApiDomain}/rpc/users`;

  const toast = useMessageToast();

  const history = useHistory();
  const { user } = useAuthState();

  const [orgData, setOrgData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  const multiselectRef = React.createRef();

  const [beginDateValue, setBeginDateValue] = React.useState(new Date());
  const [endDateValue, setEndDateValue] = React.useState(new Date());

  const [reportTypeValue, setReportTypeValue] = React.useState("Detailed");

  const onBeginDateChange = React.useCallback(date => {
    setBeginDateValue(date);
  }, []);

  const onEndDateChange = React.useCallback(date => {
    setEndDateValue(date);
  }, []);

  const onReportTypeChange = r_type => {
    setReportTypeValue(r_type);
  };

  const fetchAllUsersFlatArray = async () => {
    const users_list = [];
    const users = await fetch(`${usersApiUrl}/`);
    const userData = await users.json();
    let userDataFiltered = userData.results;
    // if (window.localStorage.getItem("LOGIN_TYPE") === "MS-Email") {
    //   userDataFiltered = userData.results;
    // } else {
    //   userDataFiltered = userData.results.filter(function(item) {
    //     return (
    //       item.roles.some(function(role) {
    //         return role.name === "Global Admin";
    //       }) ||
    //       item.clients.some(function(client) {
    //         return (
    //           client.organization.id ===
    //           user.preferences.selectedClient.organization.id
    //         );
    //       })
    //     );
    //   });
    // }

    users_list.push({
      name: "All",
      email: "*"
    });
    for (const user of userDataFiltered) {
      const item = {
        name: user.first_name + " " + user.last_name,
        email: user.email
      };
      users_list.push(item);
    }
    setUserData(users_list);
  };

  React.useEffect(() => {
    setSelectedUsersForDataStewardReport([]);
    fetchAllUsersFlatArray();
  }, [user]);

  const [
    selectedUsersForDataStewardReport,
    setSelectedUsersForDataStewardReport
  ] = React.useState([]);

  const onRemoveDataStewardReportUsersHandler = (
    selectedList,
    selectedItem
  ) => {
    setSelectedUsersForDataStewardReport(
      selectedList.filter(item => item.name !== "All")
    );
  };
  const onSelectDataStewardReportUsersHandler = (
    selectedList,
    selectedItem
  ) => {
    if (selectedItem.name === "All" && selectedItem.email === "*") {
      setSelectedUsersForDataStewardReport(userData);
    } else if (selectedList.length === userData.length - 1) {
      setSelectedUsersForDataStewardReport(userData);
    } else {
      setSelectedUsersForDataStewardReport(selectedList);
    }
  };

  const generateDownloadableDataStewardReportInCSV = compressedResponse => {
    // Extracting Json from Compressed Response
    const base64Data = compressedResponse.substring(
      1,
      compressedResponse.length - 1
    );
    const compressData = window.atob(base64Data);
    const compressedData = compressData.split("").map(function(e) {
      return e.charCodeAt(0);
    });
    const compressed = new Uint8Array(compressedData);
    try {
      const dataStewardReportObject = JSON.parse(
        pako.inflate(compressed, { to: "string" })
      );
      let columns = "";
      if (reportTypeValue === "Detailed") {
        columns += "Date, Name, Email, EID, Record IDs, Action, Risk Score";
      } else if (reportTypeValue === "Summary") {
        columns += "Name, Email, EID Count";
      }
      columns += "\n";
      let EID_Total = 0;
      if (dataStewardReportObject.result.length !== 0) {
        dataStewardReportObject.result.forEach(dataStewardReportObject => {
          for (let key in dataStewardReportObject) {
            if (key === "EID Count") {
              EID_Total = EID_Total + parseInt(dataStewardReportObject[key]);
            }
            columns += '"' + dataStewardReportObject[key] + '"' + ",";
          }
          columns += "\n";
        });
        if (reportTypeValue === "Summary") {
          columns += ',="Grand Total"' + "," + EID_Total;
          columns += "\n";
        }
      }
      const url = URL.createObjectURL(
        new Blob([columns], { type: "text/csv" })
      );
      let fileLink = document.createElement("a");
      fileLink.href = url;
      fileLink.download = "User_Actions_Report" + "_" + reportTypeValue;
      fileLink.click();
      // window.location.href = url;
    } catch (err) {
      console.log(err);
    }
  };

  const fetchDataStewardActionsReport = () => {
    if (selectedUsersForDataStewardReport.length === 0) {
      toast.error("No users selected");
      return;
    }
    if (endDateValue - beginDateValue < 0) {
      toast.error("Begin date can't be more than end date");
      return;
    }
    if ((endDateValue - beginDateValue) / 86400000 > 365) {
      toast.error("Select a valid date range of maximum 1 year");
      return;
    }

    const url = `${process.env.REACT_APP_CLIENT_CONFIG_API_DOMAIN}/rpc/data_steward_report/`;
    // const localurl = `http://localhost:8000/api/rpc/overlay_report/`;

    let mockUrl = "";

    if (reportTypeValue == "Detailed") {
      mockUrl = `/dataStewardReportDetailed.json`;
    }
    if (reportTypeValue == "Summary") {
      mockUrl = `/dataStewardReportSummary.json`;
    }

    const beginDate = new Date(beginDateValue).toISOString().slice(0, 10);
    const endDate = new Date(endDateValue).toISOString().slice(0, 10);
    const data = {
      org_name: user.preferences.selectedClient.organization.name,
      report_type: reportTypeValue,
      begin_date: beginDate,
      end_date: endDate,
      users: selectedUsersForDataStewardReport.filter(
        item => item.name !== "All"
      )
    };
    const config = {
      method: "POST",
      body: JSON.stringify(data),
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      }
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(response => response.text())
      .then(response => {
        generateDownloadableDataStewardReportInCSV(response);

        toast.info("Report successfully fetched");
      })
      .catch(e => {
        toast.error("Failed to download report" + e);
      });
  };

  return (
    <Layout>
      <Container>
        <Flex gutter={3}>
          <Flex.Item span={12}>
            <DefaultBreadcrumbs />
          </Flex.Item>
          <Flex.Item span={12}>
            <Content>
              <h1>User Actions Audit</h1>
            </Content>
            <div className={styles.dsReport}>
              <div className={styles.userMultiSelect}>
                <div className={styles.title}>Select Users(s):</div>
                <div className={styles.multiselect}>
                  <Multiselect
                    options={userData}
                    displayValue="name"
                    ref={multiselectRef}
                    placeholder=""
                    selectedValues={selectedUsersForDataStewardReport}
                    onSelect={(selectedList, selectedItem) =>
                      onSelectDataStewardReportUsersHandler(
                        selectedList,
                        selectedItem
                      )
                    }
                    onRemove={(selectedList, selectedItem) =>
                      onRemoveDataStewardReportUsersHandler(
                        selectedList,
                        selectedItem
                      )
                    }
                    style={{
                      searchBox: {
                        backgroundColor: "white",
                        border: "1px solid grey",
                        borderRadius: "1.5rem",
                        paddingTop: "0.5rem",
                        paddingLeft: "0.5rem"
                      }
                    }}
                  />
                </div>
              </div>
              <div className={styles.reportType}>
                <div className={styles.title}>Select Report Type:</div>
                <div className={styles.dropDownList}>
                  <DropDownList
                    onChange={e => onReportTypeChange(e.target.value)}
                    className={styles.dropDownList}
                  >
                    <DropDownList.Item value="Detailed">
                      Detailed View
                    </DropDownList.Item>
                    <DropDownList.Item value="Summary">
                      Summary View
                    </DropDownList.Item>
                  </DropDownList>
                </div>
              </div>

              <div className={styles.dsReportCalendar}>
                <div className={styles.date}>
                  <div className={styles.text}>Begin Date:</div>
                  <div className={styles.dateSelector}>
                    <DateTimePicker
                      onChange={onBeginDateChange}
                      value={beginDateValue}
                      format="y-MM-dd"
                      className={styles.dateSelector}
                    />
                  </div>
                </div>

                <div className={styles.date}>
                  <div className={styles.text}>End Date:</div>
                  <div className={styles.dateSelector}>
                    <DateTimePicker
                      onChange={onEndDateChange}
                      value={endDateValue}
                      format="y-MM-dd"
                      className={styles.dateSelector}
                    />
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "2rem" }}>
                <ButtonList>
                  <Button
                    primary
                    type="submit"
                    onClick={() => fetchDataStewardActionsReport()}
                  >
                    Download Report
                  </Button>
                </ButtonList>
              </div>
            </div>
          </Flex.Item>
        </Flex>
      </Container>
    </Layout>
  );
};

export default DataStewardReport;
